export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/JP-b3266baee2667e9f97f85532a3d828ae.png";